function addToCartItems(productId) {
  data = {
    items: [{
      id: productId,
      quantity: 1,
      properties: {}
    }]
  },
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() {
      jQuery.getJSON('/cart.js', function(cart) {
        $('.cart-link.js-drawer-open-right').click();
        $('body').addClass('just-added-to-cart');

      });
    },

    error: function(data, textstatus) {
      alert(data.responseJSON.message + '. ' + data.responseJSON.description);
      alert("Something went wrong. Please try again. Contact us if it doesn't help.");
    },
  });
}





// var thisButId = jQuery(form).serialize().split('id=')[1];
//       console.log(thisButId);
//         var doubleProduct = false;
//         jQuery.getJSON('/cart.js', function(cart) {
//          cart.items.forEach(function(itemThis){
//           if(itemThis.id == thisButId){
//             doubleProduct = true;
//           }
//         });
//          if(doubleProduct){
//           alert('The product is already is on the cart');
//         }else{
//           jQuery.ajax(params);
//         }
//       });


function checkIfAlreadyInTheCart(varId){

  var checkIfExist = false;
  jQuery.getJSON('/cart.js', function(cart) {
    cart.items.forEach(function(itemThis){
         // console.log(varId+ ' = '+ itemThis.id);
         if(itemThis.id == varId){
          checkIfExist = true;
        }
      });

  });


}


function addToCartVariant(thisProduct) {
  var titleProduct = thisProduct.attr('href') + '.js';
  var variantTitle = thisProduct.attr('id') ? thisProduct.attr('id').toLowerCase() : false;


  jQuery.getJSON(titleProduct, function(product) {

    var selectArray = product.variants,
    prodctId = product.id;


    if (variantTitle) {
      for (i = 0; i < selectArray.length; i++) {
        var currentTitle = selectArray[i].title.toLowerCase();


        if (currentTitle == variantTitle) {
                 //console.log('if variant here is the ID = '+selectArray[i].id);

                 var checkIfExist = false;
                 //var currentId = selectArray[i].id;
                 var currentId = selectArray[i].id;

                 jQuery.getJSON('/cart.js', function(cart) {
                  cart.items.forEach(function(itemThis){
                       // console.log(itemThis.id +' == '+ currentId);
                       if(itemThis.id == currentId){
                         checkIfExist = true;
                       }
                     });


                  if(checkIfExist){
                    $('.cart-link.js-drawer-open-right').click();
                    setTimeout(function(){
                      alert('The product is already is in the cart');    
                    },500)
                  }else{
                    addToCartItems(currentId);
                  }
                });

               }else{
                //console.log('Incorect product variant. Please check settings.')

              }
            }
          } else {
            var checkIfExist = false;
            var currentId = selectArray[0].id;

            console.log('currentId = ' + currentId);
            console.log('selectArray = ' + JSON.stringify(selectArray));


            jQuery.getJSON('/cart.js', function(cart) {
              cart.items.forEach(function(itemThis){
                console.log(itemThis.id +' == '+ currentId);
                if(itemThis.id == currentId){
                 checkIfExist = true;
               }
             });

              if(checkIfExist){
                $('.cart-link.js-drawer-open-right').click();
                setTimeout(function(){
                  alert('The product is already is in the cart');    
                },500);
              }else{
               addToCartItems(selectArray[0].id);;
             }
           });

          }


        });
}






$('a[data-lhlink][href*="/products/"], a[href*="/products/"]').each(function(){
  let dataLink = $(this).attr('href');
//    console.log(dataLink);


if(dataLink[dataLink.length -1] == '+'){
  $(this).addClass('rl');
  $(this).attr('href', $(this).attr('href').slice(0, -1));
}else if($(this).hasClass('product-item__link')){
  $(this).addClass('rl');
}else if(dataLink.indexOf("subscription") > -1){
  if($('body').attr('id') == 'sunday-keys-template-for-mainstage-3-2022-wip' || $('body').attr('id') == 'sunday-keys-template-for-ableton-live-2022-wip'){
    $(this).addClass('rl');
  }
}
});

$('a[data-lhlink][href*="/products/"]:not(.rl), a[href*="/products/"]:not(.rl)').click(function(e) {
  e.preventDefault();
  addToCartVariant($(this));
  // if($('body').attr('id') == 'sunday-keys-template-for-mainstage-3-2022-wip'){
  //      //test subs
  //    }else{
      
  //   }
  });

$('.buy_sub_btn').click(function(){

  var sub = $(this);

  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: sub.find('> form').serialize(),
    success: function() {
      jQuery.getJSON('/cart.js', function(cart) {

        $('.cart-link.js-drawer-open-right').click();
        $('body').addClass('just-added-to-cart');

      });
    },

    error: function(data, textstatus) {
      alert(data.responseJSON.message + '. ' + data.responseJSON.description);
      alert("Something went wrong. Please try again. Contact us if it doesn't help.");
    }
  });

});



$('.custom-background-4').parent('section').addClass('custom-background-4-section');

if (window.location.href.indexOf("/updates/") > -1) {
  $('body').addClass('updates-blog');
}

if (window.location.href.indexOf("/updates/") > -1) {
  $('body').addClass('updates-blog');
}

if (window.location.pathname == '/products/sunday-keys-standard-subscription' || window.location.pathname == '/products/sunday-keys-ultimate-subscription') {
  console.log(window.location.href);
  if(window.location.href.indexOf("?add-to-cart")){

       // $('#AddToCart-product-template').click();
     }
   }

   if (window.location.pathname == '/products') {
     $('body').css('opacity', 0);
     window.location.replace("/");
   }

   if (window.location.pathname == '/pages/my-subscriptions') {

    $('<a href="/pages/my-purchases" class="back-purch">< Back to My Purchases</a>').insertBefore('.page-width.page-container header');


    $('body').on('click', '.stx-message--with-success + p', function() {
      window.location.replace("/pages/my-purchases");
    });
  }




  if (window.location.pathname.includes('commerce/digital-download')) {
    $('body').css('opacity', 0);
    let fullLink = window.location.href;

    let newLink = fullLink.split('rhirukey.com')[1];
    let sqsDomain = 'https://david-pfaltzgraff-g57d.squarespace.com';

    window.location.replace(sqsDomain+newLink);
  }



  function checkoutLogin(){
    if (window.location.href.indexOf("checkout_url=") >= 0){
     $('.checkout-login').show();
   }
 }

 if (window.location.href.indexOf("/account/login") >= 0){
  checkoutLogin();
}

// $('body').on('click', function(e){
//     console.log(123)
//     var that = $(this);
//     if (that.hasClass('js-mobile-open-account')) {
//         var $accountMenu = $('#AccountDrawer');
//         $accountMenu.removeClass('is-transitioning')

//         $('#account').removeClass('js-drawer-open').removeClass('js-mobile-open-account');
//     } else {
//         // e.preventDefault();
//         // // console.log(134)
//         // var $accountMenu = $('#AccountDrawer');
//         // $accountMenu.addClass('is-transitioning')

//         // $('#account').addClass('js-drawer-open').addClass('js-mobile-open-account');
//     }
// })

$('.js-mobile-open-account').on('click', function(e){

  e.preventDefault();
    // console.log(134)
    var $accountMenu = $('#AccountDrawer');
    $accountMenu.addClass('is-transitioning')

    $('body').addClass('js-drawer-open').addClass('js-mobile-open-account');

    
    
  });



$('.js-mobile-account-close').on('click', function(){
  var $accountMenu = $('#AccountDrawer');
  $accountMenu.removeClass('is-transitioning')

  $('body').removeClass('js-drawer-open').removeClass('js-mobile-open-account')
})